// extracted by mini-css-extract-plugin
module.exports = {"gradientColorRight":"linear-gradient(to right, #3CB9C0, #07a3c8)","whiteColor":"#FFFFFF","container":"HomePanel_container__MeBfP","touch":"HomePanel_touch__3CE8T"};